import axios from 'axios'

export const getAllTeams = async () => {
  const url = process.env.REACT_APP_ADMIN_API + '/teams'
  const response = await axios.get(url, {})
  return response.data.vercelResponse
}
